import React, { useState, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import AsyncSelect from 'Common/Components/AsyncSelect/AsyncSelect';
import useGrouping from 'Common/Utils/Hooks/useGrouping';
import errorCb from 'Common/Utils/errorCb';
import classes from '../updater.module.css';
import { fetchTemplates } from '../../../service';

function UpdateAsyncSelectField({
    field,
    initialValue,
    onChange,
    year
}) {
    const [value, setValue] = useState(initialValue);
    const globalDispatch = useDispatch();
    const grouping = useGrouping();
    const errorCallback = useMemo(() => errorCb(null, 'Error fetching Templates.', globalDispatch), [globalDispatch]);
    const templateDataSource = useMemo(() => fetchTemplates(grouping, year, errorCallback), [grouping, year, errorCallback]);

    return (
        <FormControl className={classes['form-control']}>
            <InputLabel id={`update-field__${field}__label`} htmlFor={`update-field__${field}`} shrink>{field}</InputLabel>
            <AsyncSelect
                id={`update-field__${field}`}
                dataSource={templateDataSource}
                keyField="id"
                valueField="name"
                className={classes['form-input']}
                value={value || null}
                required
                onChange={handleValueChange}
            />
        </FormControl>
    );

    function handleValueChange(e) {
        const val = e.target.value;
        setValue(val);
        onChange(val);
    }
}

UpdateAsyncSelectField.propTypes = {
    field: PropTypes.string.isRequired,
    initialValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    year: PropTypes.string
};

export default UpdateAsyncSelectField;
